import axios from "axios";
import { encryptText, decryptText } from "../utilis/encryption";

const { REACT_APP_BASE_URL, REACT_APP_ENABLE_ENCRYPTION } = process.env;
const enableEncryption = REACT_APP_ENABLE_ENCRYPTION === "true";
const Axios = axios.create({
  baseURL: REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ----------------------- REQUEST INTERCEPTOR ----------------------- */
Axios.interceptors.request.use(
  async (config) => {
    const token = JSON.parse(localStorage.getItem("token"));

    if (token && config.headers) {
      config.headers.token = token;
    }

    const isS3Url = config?.url?.includes("amazonaws.com");
    const isCompressUrl = config?.url?.includes("compress");

    if (enableEncryption && config.data && !isS3Url && !isCompressUrl) {
      const encrypted = await encryptText(JSON.stringify(config.data));
      config.data = { payload: encrypted };
    }


    return config;
  },
  (error) => Promise.reject(error)
);

/* ----------------------- RESPONSE INTERCEPTOR ----------------------- */
Axios.interceptors.response.use(
  async (response) => {
    const { data } = response;
    // Decrypt response payload
    if (enableEncryption && typeof data?.response?.data === "string") {
      const decrypted = await decryptText(data?.response?.data);
      response.data.response.data = JSON.parse(decrypted);
    }
    return response;
  },
  async (error) => {
    // Also decrypt error messages if BE encrypts them
    if (enableEncryption && error?.response?.data?.payload) {
      try {
        const decrypted = await decryptText(error.response.data.payload);
        error.response.data = JSON.parse(decrypted);
      } catch (_) {}
    }

    throw error;
  }
);

export default Axios;